import { Badge } from '@/components/ui/badge';
import { capitalizeFirstLetter } from '@/util/util';

import { TimeElementType } from '../MessageArea';

export const TimeElement = ({ created }: Partial<TimeElementType>) => {
  return (
    <span key={created}>
      <span className="flex items-center pt-3">
        <span className="h-px flex-auto bg-stroke shadow-[0_1px_0_var(--color-background)]" />
        <Badge
          type="outline"
          flavour="neutral"
          size="xs"
          rounded={false}
          className="mx-0.5 shrink-0 bg-background"
        >
          {capitalizeFirstLetter(created)}
        </Badge>
        <span className="h-px flex-auto bg-stroke shadow-[0_1px_0_var(--color-background)]" />
      </span>
    </span>
  );
};
